module.exports = __webpack_public_path__ + "img/69.900ce4b1.jpg";